import dashboard from './dashboard';
import pages from './pages';
import utilities from './utilities';
import other from './other';

import smartLocker from './smartLocker';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, smartLocker]
};

export default menuItems;
